/**
 * Maison d'Esteban — FOMO: etichete în coș, caseta „Economisești azi” cu timer, rândul „În stoc” pe PDP,
 * panglica K4 pe carduri și panoul K1 în colecții. Configurarea vine din snippets/est-fomo-boot.liquid.
 *
 * mode = 'demo': alegere prin cookie (validare vizuală pe duplicat) · 'real': doar date reale din Liquid
 * (data-est-inv = stocul variantei, data-est-rank = rangul zilei din metafield) și ceasul de curier.
 * Sertarul e re-randat de temă (morph) la fiecare schimbare → reaplicăm la fiecare mutație, idempotent.
 */
const cfgEl = document.getElementById('est-fomo-cfg');
const C = cfgEl ? JSON.parse(cfgEl.textContent) : null;
const DEMO = C && C.mode === 'demo';
const REAL = C && C.mode === 'real';
const ON = DEMO || REAL;

const getCookie = (k) => (document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')) || [])[1];
const setCookie = (k, v) => {
  document.cookie = `${k}=${v}; path=/; SameSite=Lax`;
};
const pad = (n) => String(n).padStart(2, '0');
const DAYS = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];

function roNow() {
  const f = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  });
  const p = Object.fromEntries(f.formatToParts(new Date()).map((x) => [x.type, x.value]));
  return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
}
const isWork = (d) => d.getDay() !== 0 && d.getDay() !== 6;
const MONTHS = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
const fmtDate = (d) => `${d.getDate()} ${MONTHS[d.getMonth()]}`;
// metafield est.restock_eta: dată AAAA-LL-ZZ → „12 noiembrie”; altfel textul ca atare; gol → fără fereastră
const fmtEta = (v) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || '');
  return m ? fmtDate(new Date(+m[1], +m[2] - 1, +m[3])) : v || '';
};

/* ---------- textul de sub „Economisești azi” ---------- */
// Timerul demo pornește la prima afișare și, când expiră, dispare complet (nu se reia la zero).
// Pornirea se ține 24 h în localStorage, deci un refresh nu-l repornește.
function resLeft() {
  const total = (C.resMin || 15) * 60;
  const now = Date.now();
  let start = 0;
  try {
    start = +localStorage.getItem('est_res_start') || 0;
  } catch (_) {}
  if (!start || now - start > 24 * 3600 * 1000) {
    start = now;
    try {
      localStorage.setItem('est_res_start', String(start));
    } catch (_) {}
  }
  const left = total - Math.floor((now - start) / 1000);
  if (left <= 0) return null;
  return `${Math.floor(left / 60)}m ${pad(left % 60)}s`;
}
function shipLine() {
  const n = roNow();
  const cut = new Date(n);
  cut.setHours(C.cutoff || 14, 0, 0, 0);
  if (isWork(n) && n < cut) {
    const s = Math.floor((cut - n) / 1000);
    const h = Math.floor(s / 3600);
    const t = h > 0 ? `${h}h ${pad(Math.floor((s % 3600) / 60))}m` : `${Math.floor(s / 60)}m ${pad(s % 60)}s`;
    return C.saveReal.replace('[t]', `<b>${t}</b>`);
  }
  const d = new Date(n);
  do d.setDate(d.getDate() + 1);
  while (!isWork(d));
  return C.saveRealLate.replace('[zi]', DAYS[d.getDay()]);
}
// bulina din bara de progres, în continuarea mesajului (textul barei e randat de server → o readăugăm după fiecare morph)
function progChip() {
  if (DEMO) {
    const t = resLeft();
    return t ? C.progDemo.replace('[t]', `<b>${t}</b>`) : '';
  }
  const n = roNow();
  const cut = new Date(n);
  cut.setHours(C.cutoff || 14, 0, 0, 0);
  if (!(isWork(n) && n < cut)) return '';
  const sec = Math.floor((cut - n) / 1000);
  const h = Math.floor(sec / 3600);
  const t = h > 0 ? `${h}h ${pad(Math.floor((sec % 3600) / 60))}m` : `${Math.floor(sec / 60)}m ${pad(sec % 60)}s`;
  return C.progReal.replace('[t]', `<b>${t}</b>`);
}
function paintProgChips() {
  document.querySelectorAll('.est-prog__msg').forEach((msg) => {
    let chip = msg.querySelector('.est-prog-chip');
    const html = progChip();
    if (!html) {
      if (chip) chip.remove();
      return;
    }
    if (!chip) {
      msg.append(' ');
      chip = document.createElement('span');
      chip.className = 'est-prog-chip';
      msg.append(chip);
    }
    if (chip.dataset.v !== html || !chip.firstChild) {
      chip.dataset.v = html;
      chip.innerHTML = html;
    }
  });
}
function paintSaveLines() {
  paintProgChips();
  document.querySelectorAll('[data-est-save-line]').forEach((el) => {
    const t = DEMO ? resLeft() : '';
    const html = DEMO ? (t ? C.saveDemo.replace('[t]', `<b>${t}</b>`) : '') : shipLine();
    if (el.dataset.v !== html || !el.firstElementChild) {
      el.dataset.v = html;
      // un singur <span>: textul și timerul curg pe același rând (rândul e flex doar pentru punct)
      el.innerHTML = `<span>${html}</span>`;
    }
  });
}

/* ---------- etichetele din coș: o etichetă pe parfum, prioritar stocul ---------- */
const genderOf = (type) => {
  const t = (type || '').toLowerCase();
  if (t.includes('femei') || t.includes('dam')) return 'femei';
  if (t.includes('barbat') || t.includes('bărbat')) return 'bărbați';
  return 'unisex';
};
const pill = (cls, html) => `<span class="est-fp__pill est-fp__pill--${cls}">${html}</span>`;

function paintCart() {
  document.querySelectorAll('cart-items-component').forEach((root) => {
    const rows = [...root.querySelectorAll('tr.cart-items__table-row[data-key]')];
    const paid = rows.filter((r) => r.dataset.estFree !== '1');
    let low = null;
    let top = null;
    if (DEMO && rows.length >= 2 && paid.length) {
      const vid = (r) => (r.dataset.key || '').split(':')[0];
      const saved = getCookie('est_fl');
      low = paid.find((r) => vid(r) === saved) || null;
      if (!low) {
        low = paid[Math.floor(Math.random() * paid.length)];
        setCookie('est_fl', vid(low));
      }
      top = paid.find((r) => r !== low) || null;
    }
    if (REAL) {
      const lows = paid
        .filter((r) => +r.dataset.estInv > 0 && +r.dataset.estInv <= C.lowMax)
        .sort((a, b) => +a.dataset.estInv - +b.dataset.estInv);
      low = lows[0] || null;
      const ranked = paid
        .filter((r) => r !== low && +r.dataset.estRank >= 1 && +r.dataset.estRank <= 10)
        .sort((a, b) => +a.dataset.estRank - +b.dataset.estRank);
      top = ranked[0] || null;
    }
    rows.forEach((r) => {
      const slot = r.querySelector('[data-est-fp]');
      if (!slot) return;
      let html = '';
      if (r === low) html = pill('low', `<i aria-hidden="true"></i>${C.lowTxt}`);
      else if (r === top) html = pill('top', `★ ${C.topTxt.replace('[gen]', genderOf(r.dataset.estType))}`);
      // morph-ul temei poate goli slotul dar păstra data-v → verificăm și conținutul real
      const stale = html ? !slot.firstElementChild : !!slot.firstElementChild;
      if (slot.dataset.v !== html || stale) {
        slot.dataset.v = html;
        slot.innerHTML = html;
      }
    });
  });
  paintSaveLines();
}

/* „1 buc. ▾” → trece prin componenta de cantitate a temei (același drum de actualizare ca +/−) */
document.addEventListener('change', (e) => {
  const sel = e.target;
  if (!(sel instanceof HTMLSelectElement) || !sel.matches('.est-qsel select')) return;
  const row = sel.closest('tr');
  const input = row && row.querySelector('input[name="updates[]"]');
  const comp = input && input.closest('.quantity-selector');
  if (!input || !comp || typeof comp.setQuantity !== 'function') return;
  input.value = sel.value;
  comp.setQuantity({ target: input, preventDefault() {} });
});

/* ---------- PDP: rândul „În stoc” (doar pe primul produs deschis în sesiune) ---------- */
function paintPdp() {
  const row = document.querySelector('.estp-tr[data-est-inv]');
  if (!row || row.dataset.estDone) return;
  row.dataset.estDone = '1';
  const handle = row.dataset.estHandle;
  let first = getCookie('est_fpdp');
  if (!first) {
    first = handle;
    setCookie('est_fpdp', handle);
  }
  if (first !== handle) return;
  const inv = +row.dataset.estInv;
  const eta = REAL ? fmtEta(row.dataset.estRestock) : fmtDate(addDays(roNow(), +C.pdpEtaDays || 28));
  if (REAL && !(inv > 0 && inv < C.pdpMax)) return;
  const ok = row.querySelector('.is-ok');
  if (!ok) return;
  const wrap = document.createElement('span');
  wrap.className = 'est-pdpl';
  wrap.innerHTML =
    `<button type="button" class="est-pdpl__btn" aria-expanded="false"><span class="est-pdpl__ring" aria-hidden="true"></span>${C.pdpTxt}` +
    (eta ? '<span class="est-pdpl__i" aria-hidden="true">i</span>' : '') +
    `</button>` +
    (eta
      ? `<span class="est-pdpl__pop" role="dialog" aria-label="${C.pdpTxt}" hidden>` +
        `<button type="button" class="est-pdpl__x" aria-label="Închide">×</button>` +
        `<span class="est-pdpl__pt"><span class="est-pdpl__dot" aria-hidden="true"></span>${C.pdpPopTitle}</span>` +
        `<span class="est-pdpl__pb">${C.pdpPopTxt.replace('[eta]', `<b>${eta}</b>`)}</span></span>`
      : '');
  ok.replaceWith(wrap);
  const btn = wrap.querySelector('button');
  const pop = wrap.querySelector('.est-pdpl__pop');
  if (pop) {
    const toggle = (show) => {
      pop.hidden = !show;
      btn.setAttribute('aria-expanded', String(show));
    };
    btn.addEventListener('click', (ev) => {
      ev.stopPropagation();
      toggle(pop.hidden);
    });
    pop.addEventListener('click', (ev) => ev.stopPropagation());
    pop.querySelector('.est-pdpl__x').addEventListener('click', () => toggle(false));
    document.addEventListener('click', () => toggle(false));
    document.addEventListener('keydown', (ev) => ev.key === 'Escape' && toggle(false));
  }
}

/* ---------- colecții: panglica K4 + panoul K1 (doar pagina 1) ---------- */
function seeded(seed) {
  let s = seed >>> 0;
  return () => ((s = (s * 1664525 + 1013904223) >>> 0) / 4294967296);
}
function paintRibbons() {
  const cards = [...document.querySelectorAll('product-card')].filter((c) => !c.dataset.estRib);
  if (!cards.length) return;
  let seed = +getCookie('est_frs');
  if (!seed) {
    seed = Math.floor(Math.random() * 1e9) + 1;
    setCookie('est_frs', seed);
  }
  const rnd = seeded(seed);
  cards.forEach((card) => {
    card.dataset.estRib = '1';
    let text = '';
    if (DEMO && rnd() < (C.ribbonPct || 30) / 100) text = C.ribbonDemo;
    if (REAL) {
      const inv = +card.dataset.estInv;
      const rank = +card.dataset.estRank;
      if (inv > 0 && inv <= C.lowMax) text = C.ribbonDemo;
      else if (rank >= 1 && rank <= (C.ribbonRealTop || 10)) text = C.ribbonReal;
    }
    if (!text) return;
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    gallery.classList.add('est-rib-host');
    const rib = document.createElement('span');
    rib.className = 'est-rib';
    rib.setAttribute('aria-hidden', 'true');
    rib.innerHTML = `<span>${text}</span>`;
    gallery.appendChild(rib);
  });
}

function midnightLeft() {
  const n = roNow();
  const l = 86400 - (n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds());
  return { h: pad(Math.floor(l / 3600)), m: pad(Math.floor((l % 3600) / 60)), s: pad(l % 60) };
}
function paintK1() {
  if (!C.k1On || document.querySelector('.est-k1')) return;
  if (REAL && !(+C.ordersToday > 0)) return;
  const cards = [...document.querySelectorAll('product-card')];
  if (cards.length <= C.k1After) return;
  let item = cards[C.k1After - 1];
  while (item.parentElement && !getComputedStyle(item.parentElement).display.includes('grid')) item = item.parentElement;
  const grid = item.parentElement;
  if (!grid) return;
  // după un rând plin: avansăm până la ultimul element de pe rândul curent
  const kids = [...grid.children].filter((k) => k.offsetParent);
  let i = kids.indexOf(item);
  while (i >= 0 && i < kids.length - 1 && kids[i + 1].getBoundingClientRect().top <= kids[i].getBoundingClientRect().top + 5) i++;
  const after = kids[i] || item;
  const el = document.createElement(after.tagName === 'LI' ? 'li' : 'div');
  el.className = 'est-k1';
  const title = REAL ? C.k1RealTitle.replace('[n]', Number(C.ordersToday).toLocaleString('ro-RO')) : C.k1Title;
  el.innerHTML =
    `<span class="est-k1__eye">${C.k1Eyebrow}</span><p class="est-k1__t">${title}</p>` +
    (DEMO ? '<span class="est-k1__bar" aria-hidden="true"><i></i></span>' : '') +
    `<span class="est-k1__dg" role="timer" aria-label="Timp rămas azi">` +
    `<span class="est-k1__d"><b data-k1="h">00</b><small>ore</small></span><span class="est-k1__c">:</span>` +
    `<span class="est-k1__d"><b data-k1="m">00</b><small>min</small></span><span class="est-k1__c">:</span>` +
    `<span class="est-k1__d"><b data-k1="s">00</b><small>sec</small></span></span>` +
    `<span class="est-k1__sub">${C.k1Sub}</span>`;
  after.after(el);
  tickK1();
}
function tickK1() {
  const els = document.querySelectorAll('[data-k1]');
  if (!els.length) return;
  const v = midnightLeft();
  els.forEach((e) => {
    if (e.textContent !== v[e.dataset.k1]) e.textContent = v[e.dataset.k1];
  });
}

/* ---------- pornire ---------- */
if (C) {
  if (ON) {
    paintCart();
    if (C.isProduct) paintPdp();
    if (C.isCollection) {
      paintRibbons();
      paintK1();
    }
    let t = null;
    new MutationObserver((list) => {
      // ignorăm mutațiile făcute de noi (etichete, timer), ca să nu re-intrăm în buclă
      if (list.every((m) => m.target.closest && m.target.closest('[data-est-fp],[data-est-save-line],.est-prog-chip,.est-prog__msg,.est-k1,.est-rib'))) return;
      clearTimeout(t);
      t = setTimeout(() => {
        paintCart();
        if (C.isCollection) paintRibbons();
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
    setInterval(() => {
      paintSaveLines();
      tickK1();
    }, 1000);
  }
}
